<template>
  <div>
    <b-container class="container card">
      <div class="card">
        <div class="card-header">
          <div>
            <i class="fa fa-search"></i>
            <span>بحث</span>
          </div>
        </div>
        <div class="card-body">
          <div class="container">
            <div class="form row card-search">
              <div class="form-group col-md-3">
                <label for="">كود الصيانة</label>
                <input type="text" class="form-control" v-model="s_id" />
              </div>

              <div class="form-group col-md-3">
                <label for="">كود الباص</label>
                <input type="text" class="form-control" v-model="s_busID" />
              </div>

              <div class="form-group col-md-3">
                <label for="">المكلف بالصيانة</label>
                <select
                  class="browser-default custom-select"
                  v-model="s_empFollow"
                >
                  <option v-for="emp in emps" :value="emp.id" :key="emp.id">
                    <span> {{ emp.Fname }} </span>
                    <span> {{ emp.Ffname }} </span>
                  </option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <button @click="clear" class="btn btn-danger">
                  الغاء البحث
                </button>
                <button v-if="c_print" @click="print" class="btn btn-success">
                  طباعة
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul class="nav nav-tabs view-mode">
        <li class="nav-item ">
          <a class="nav-link active" data-toggle="tab" href="#home">
            <i class="fa fa-table"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#menu1">
            <i class="fa fa-bars"></i>
          </a>
        </li>
      </ul>
      <div class="m-auto">
        <b-button v-if="c_add" to="createBusM" variant="outline-primary">إضافة</b-button>
        <div class="std-count">
          <span class="text-danger">
            عدد الحافلات المصانة
          </span>
          <span> | </span>
          <span class="text-success"> {{ items.length }} </span>
        </div>
      </div>
      <div class="tab-content">
        <div class="tab-pane container active overflow" id="home">
          <!-- Main table element -->

          <b-table
            :busy="isBusy"
            :bordered="true"
            :no-border-collapse="true"
            show-empty
            striped
            hover
            small
            stacked="sm"
            :fields="fields"
            :current-page="currentPage"
            :per-page="10"
            :items="filtered"
            head-variant="dark"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            sort-icon-left
          >
            <template v-slot:head(id) style="background-color:red;">
              <span class="text-info">كود الصيانة</span>
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> جارى التحميل ... </strong>
              </div>
            </template>
            <template v-slot:table-colgroup="scope">
              <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.key === 'id' ? '20px' : '20px' }"
              />
            </template>
            <template slot="top-row" slot-scope="{ fields }">
              <td v-for="field in fields" :key="field.key">
                <input
                  v-model="filters[field.key]"
                  :placeholder="field.label"
                />
              </td>
            </template>
            <template v-slot:cell(actions)="row">
              <b-button
              v-if="c_update"
                size="sm"
                @click="info(row.item, row.index, $event.target)"
                class="mr-1"
                :to="'/updateBusM/' + row.item.id"
                variant="outline-warning"
              >
                تعديل
              </b-button>
              <b-button
               v-if="c_delete"
                size="sm"
                @click="info(row.item, row.index, $event.target)"
                class="mr-1"
                variant="outline-danger"
              >
                حذف
              </b-button>
            </template>
          </b-table>
          <b-row>
            <b-col sm="7" md="6" class="m-auto">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class=""
              ></b-pagination>
            </b-col>
          </b-row>
          <!-- Info modal -->
          <b-modal
            :id="infoModal.id"
            hide-footer
            ref="my-modal"
            body-bg-variant="light"
            body-text-variant="danger"
            footer-bg-variant="warning"
            footer-text-variant="light"
            @hide="resetInfoModal"
          >
            <div class="d-block text-center">
              <b-row>
                <div class="card-body">
                  <span>
                    هل انت متأكد من حذف الصيانة رقم ؟
                  </span>
                  <span class="text-dark">{{ delitem.boardNum }}</span>
                </div>
              </b-row>
              <div class="card-footer">
                <b-container>
                  <b-row>
                    <b-button
                      class="col-md-6 btn-danger"
                      :disabled="busy"
                      @click="remove(delitem)"
                    >
                      <b-spinner
                        v-if="busy"
                        small
                        type="grow"
                        style="margin-bottom: 3px;"
                      ></b-spinner>
                      {{ btnDelMessage }}</b-button
                    >
                    <b-button class="col-md-6 btn-secondary" @click="hideModal"
                      >الغاء</b-button
                    >
                  </b-row>
                </b-container>
              </div>
            </div>
          </b-modal>
        </div>
        <div class="tab-pane container fade" id="menu1">
          <div class="container">
            <div class="row">
              <div class="col-md-3" v-for="item in items" :key="item.id">
                <div class="itm card">
                  <div class="card-header">
                    <span>كود الباص</span>
                    <span> | </span>
                    <span class="text-warning"> {{ item.busID }} </span>
                  </div>
                  <table>
                    <tr>
                      <td>كود الصيانة</td>
                      <td>|</td>
                      <td>{{ item.id }}</td>
                    </tr>
                    <tr>
                      <td>نوع الصيانة</td>
                      <td>|</td>
                      <td>{{ item.mainType }}</td>
                    </tr>
                    <tr>
                      <td>تكلفة الصيانة</td>
                      <td>|</td>
                      <td>{{ item.coseMain }}</td>
                    </tr>
                    <tr>
                      <td>المكلف بالصيانة</td>
                      <td>|</td>
                      <td>
                        <span> {{ item.Fname }} </span
                        ><span> {{ item.Ffname }} </span>
                      </td>
                    </tr>
                    <tr>
                      <td>بداية الصيانة</td>
                      <td>|</td>
                      <td>{{ item.mainStart }}</td>
                    </tr>
                    <tr>
                      <td>نهاية الصيانة</td>
                      <td>|</td>
                      <td>{{ item.mainEnd }}</td>
                    </tr>
                    <tr>
                      <td>التكاليف الكلية</td>
                      <td>|</td>
                      <td>{{ item.totalCost }}</td>
                    </tr>
                  </table>

                  <div class="card-footer m-auto">
                    <b-button
                     v-if="c_update"
                      size="sm"
                      class="mr-1"
                      :to="'/updateBusM/' + item.id"
                      variant="outline-warning"
                    >
                      تعديل
                    </b-button>
                    <b-button
                     v-if="c_delete"
                      size="sm"
                      @click="infoDel(item.id)"
                      class="mr-1"
                      variant="outline-danger"
                    >
                      حذف
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
//import axios from 'axios'
import { mapState, mapGetters, mapActions } from "vuex";
import indexLayout from "../../layouts/indexLayout.vue";
export default {
  name: "buses",
  data() {
    return {
      s_id: "",
      s_busID: "",
      s_empFollow: "",

      isBusy: true,
      busy: false,
      btnDelMessage: "حذف",
      items: [],
      delitem: "",
      bodyBgVariant: "light",
      bodyTextVariant: "dark",
      footerBgVariant: "warning",
      footerTextVariant: "dark",
        /*check role */
c_add:false,
c_update:false,
c_delete:false,
c_print:false,

/*check end */
      fields: [
        {
          key: "id",
          label: "كود الصيانة",
          sortable: true,
          class: "f-id",
          sortDirection: "desc",
          tdClass: "fid",
        },
        {
          key: "busID",
          label: "كود الباص",
          sortable: true,
          class: "text-center",
        },
        {
          key: "mainType",
          label: "نوع الصيانة",
          sortable: true,
          class: "text-center",
        },
        {
          key: "Fname",
          label: "المكلف بالصيانة",
          sortable: true,
          class: "text-center",
        },

        { key: "actions", label: "" },
      ],
      filters: {
        id: "",
        busID: "",
        empFollow: "",
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: "",
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  created() {
    this.$emit("update:layout", indexLayout);
     this.Role_check();
  },

  computed: {
    ...mapGetters({
      load: "busMainMod/GET_ALLDATA",
    }),
    ...mapState(["emps"]),

    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    filtered() {
      const filtered = this.items.filter((item) => {
        return Object.keys(this.filters).every((key) =>
          String(item[key]).includes(this.filters[key])
        );
      });
      return filtered.length > 0
        ? filtered
        : [
            {
              id: "",
              busID: "",
              empFollow: "",
            },
          ];
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    ...mapActions({
      loadData: "busMainMod/fetchData",
      deleData: "busMainMod/deleteData",
    }),
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.delitem = item;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    infoDel: function(id) {
      var item = this.items.find((todo) => todo.id == id);
      this.infoModal.title = item.id;
      this.delitem = item;
      this.$root.$emit("bv::show::modal", this.infoModal.id);
    },
    async remove(stdRow) {
      this.busy = true;
      await this.deleData(stdRow);
      this.btnDelMessage = "تم الحذف";
      this.busy = false;
      this.items = this.load;
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    async getData() {
      if (this.load.length > 0) {
        this.items = this.load;
        this.totalRows = this.items.length;
        this.isBusy = false;
      } else {
        await this.$store.dispatch("busMainMod/fetchData");
        this.items = this.load;
        this.totalRows = this.items.length;
        this.isBusy = false;
      }
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    Cfilter() {
      this.items = this.load;
      this.items = this.items.filter((t) =>
        t.id.toString().includes(this.s_id)
      );

      this.items = this.items.filter((t) =>
        t.busID.toString().includes(this.s_busID)
      );

      this.items = this.items.filter((t) =>
        t.empFollow.toString().includes(this.s_empFollow)
      );
    },
    clear() {
      this.s_id = "";
      this.s_busID = "";
      this.s_empFollow = "";
    },
    print() {
      this.$router.push({ name: "busMainR", params: { load: this.items } });
    },
      Role_check(){
this.c_add =this.check.busM_add ==1 ? true : false;
this.c_update =this.check.busM_update ==1 ? true : false;
this.c_delete =this.check.busM_delete ==1 ? true : false;
this.c_print =this.check.busM_print ==1 ? true : false;

}
  },
  watch: {
    s_id: function() {
      this.Cfilter();
    },
    s_busID: function() {
      this.Cfilter();
    },
    s_empFollow: function() {
      this.Cfilter();
    },
  },
};
</script>
<style lang="scss" scoped>
.b-table-top-row > td:last-child {
  visibility: hidden;
}
.nav-link.active {
  background-color: #ddab2b !important;
}
.fid {
  background-color: #ddab2b;
}
.itm {
  margin: 10px 0px;
  box-shadow: 0px 0px 6px 1px black;
  -moz-box-shadow: 0px 0px 6px 1px black;
  -o-box-shadow: 0px 0px 6px 1px black;
  -webkit-box-shadow: 0px 0px 6px 1px black;
}
</style>
